import { computed, ref, watch, onMounted, onBeforeUnmount } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43b4ea2a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "download-btn-wrap"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 3,
  class: "handle-content"
};
const _hoisted_7 = {
  class: "handle-content__permission"
};
const _hoisted_8 = {
  key: 0,
  style: {
    "margin-right": "16px"
  }
};
const _hoisted_9 = {
  style: {
    "margin-right": "16px"
  }
};
const _hoisted_10 = {
  class: "handle-content__detail"
};
const _hoisted_11 = {
  key: 4,
  class: "amount-wrap"
};
const _hoisted_12 = {
  class: "pagination-content"
};
const _hoisted_13 = {
  class: "total_count"
};
const _hoisted_14 = {
  style: {
    "margin": "0 8px"
  }
};
import { message } from 'ant-design-vue';
import { awaitWrap, OK, reportEvent } from '@/common';
import { Modal } from 'ant-design-vue';
// import { Revenue } from '@/types/revenue'
import OrderModal from '@/views/orderManage/orderList/components/OrderModal.vue';
import { batchRefundSubmit, exportOrderList, queryOrderListV2, resendOrder } from '@/api/orderApi';
import { useStore } from '@/store';
import dayjs from 'dayjs';
import useFilterHeader from '../../newOrderList/components/useFilterHeader';
import OrderDetail from '@/views/orderManage/newOrderList/orderDetail.vue';
import BatchSureModal from './BatchSureModal.vue';
import BatchRefundModal from './BatchRefundModal.vue';
import RefundModal from './RefundModal.vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderTableBlock',
  props: {
    tableType: null
  },
  emits: ['updateLoading', 'updateApp'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    _useCssVars(_ctx => ({
      "ef401312": slotheight.value,
      "3e49ba86": tableMinHeight.value
    }));
    const pageSizeList = [{
      label: '10条/页',
      value: 10
    }, {
      label: '20条/页',
      value: 20
    }, {
      label: '50条/页',
      value: 50
    }, {
      label: '100条/页',
      value: 100
    }];
    const payStatusList = [{
      label: '全部',
      value: null
    }, {
      label: '未支付',
      value: '0'
    }, {
      label: '失败',
      value: '10'
    }, {
      label: '成功',
      value: '20'
    }, {
      label: '成功',
      value: '21'
    }, {
      label: '成功',
      value: '22'
    }, {
      label: '退款',
      value: '30'
    }];
    const sortByObj = {
      createDate: 'pre_order_time',
      thirdPayTime: 'orig_third_order_no'
    };
    const {
      shipStatusList
    } = useFilterHeader();
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const loading = ref(false);
    const selectedRowKeys = ref([]);
    // 跨页面选择状态管理
    const allSelectedKeys = ref(new Map());
    const currentPageSelectedKeys = ref([]);
    // 存储选中项的详细信息 (orderNo, prodId等)
    const allSelectedRecords = ref(new Map());
    const currentPageSelectedRecords = ref([]);
    const columns = ref([{
      title: 'DBT订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '内购ID',
      dataIndex: 'prodId',
      key: 'prodId'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '价格',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '币种',
      dataIndex: 'currency',
      key: 'currency'
    }, {
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }]);
    const columnsOrder = [{
      title: 'DBT订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '三方订单号',
      dataIndex: 'platOrderNo',
      key: 'platOrderNo'
    }, {
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '金额',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '创建时间',
      dataIndex: 'createDate',
      key: 'createDate',
      width: 180
    }, {
      title: '支付时间',
      dataIndex: 'thirdPayTime',
      key: 'thirdPayTime',
      width: 180
    }, {
      title: '支付状态',
      dataIndex: 'payStatus',
      key: 'payStatus',
      width: 80,
      fixed: 'right'
    }, {
      title: '道具状态',
      dataIndex: 'shipStatus',
      key: 'shipStatus',
      width: 80,
      fixed: 'right'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right',
      fixed: 'right'
    }];
    const columnsReimburse = [{
      title: 'DBT订单号',
      dataIndex: 'orderNo',
      key: 'orderNo'
    }, {
      title: '商品名称',
      dataIndex: 'prodName',
      key: 'prodName'
    }, {
      title: '价格',
      dataIndex: 'amount',
      key: 'amount'
    }, {
      title: '退款金额',
      dataIndex: 'refundAmount',
      key: 'refundAmount'
    }, {
      title: '币种',
      dataIndex: 'refundCurrency',
      key: 'refundCurrency'
    }, {
      title: '设备ID',
      dataIndex: 'deviceId',
      key: 'deviceId'
    }, {
      title: '退款渠道',
      dataIndex: 'payChnl',
      key: 'payChnl'
    }, {
      title: '退款状态',
      dataIndex: 'refundStatus',
      key: 'refundStatus'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const orderRef = ref();
    const dataSource = ref([]);
    const total = ref(0);
    const pageIndex = ref(1);
    const pageSize = ref(20);
    const searchObj = ref({});
    const pageArrow = ref('');
    const slotheight = ref(`${window.innerHeight - 220}px`);
    const tableheight = ref(`${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`);
    const tableMinHeight = ref(`${window.innerHeight - (props.tableType === '1' ? 360 : 320)}px`);
    const tableRef = ref();
    const refundVisible = ref(false);
    const refundItem = ref({});
    const orderDetailRef = ref(null);
    const hasNextPage = ref(false);
    const sortBy = ref(null);
    const sortType = ref('desc');
    const sureModalVisible = ref(false);
    const modalLoading = ref(false);
    const batchRefundVisible = ref(false);
    const batchRefundLoading = ref(false);
    const getData = async () => {
      const params = {
        pageCursor: '',
        pageCursorOrderNo: '',
        pageArrow: pageArrow.value,
        pageSize: pageSize.value,
        sortBy: sortBy.value ? sortByObj[sortBy.value] : 'order_no',
        sortType: sortType.value,
        ...searchObj.value
      };
      await getDataSource(params);
    };
    const getDataSource = async params => {
      // 判断是否是批量输入的订单号
      if (params.orderUnion && params.orderUnion.includes(';')) {
        params.orderNos = params.orderUnion.split(';');
        delete params.orderUnion;
        // 如果没有选择产品名称提示选择产品名称
        if (!params.dbtId) {
          message.warning('批量输入订单号时请选择产品');
          return;
        }
      }
      const startTime = new Date().getTime();
      loading.value = true;
      emit('updateLoading', true);
      try {
        const [err, res] = await awaitWrap(queryOrderListV2(params));
        if (err) {
          return loading.value = false;
        }
        if (res) {
          var _res$data, _res$data$total, _res$data2, _res$data3, _dataSource$value;
          loading.value = false;
          dataSource.value = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.list) || [];
          // 恢复当前页的选择状态
          const savedSelection = allSelectedKeys.value.get(pageIndex.value) || [];
          selectedRowKeys.value = savedSelection;
          currentPageSelectedKeys.value = savedSelection;
          // 恢复当前页选中记录的详细信息
          const savedRecords = allSelectedRecords.value.get(pageIndex.value) || [];
          currentPageSelectedRecords.value = savedRecords;
          total.value = (_res$data$total = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.total) !== null && _res$data$total !== void 0 ? _res$data$total : 0;
          hasNextPage.value = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.hasNextPage;
          // 再原来回显的基础上增加批量时不回显产品
          if ((_dataSource$value = dataSource.value) !== null && _dataSource$value !== void 0 && _dataSource$value.length && pageIndex.value === 1 && !params.orderNos) {
            emit('updateApp', dataSource.value[0].dbtId);
          }
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '订单查询',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'succeed'
            }
          });
        } else {
          loading.value = false;
          reportEvent({
            eventName: '_search',
            properties: {
              ui_name: '订单查询',
              app_name: '',
              return_duration: (new Date().getTime() - startTime) / 1000,
              query_status: 'failed'
            }
          });
        }
      } catch (e) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: '订单查询',
            app_name: '',
            return_duration: (new Date().getTime() - startTime) / 1000,
            query_status: 'failed'
          }
        });
      }
      loading.value = false;
      emit('updateLoading', false);
    };
    const searchData = async obj => {
      pageIndex.value = 1;
      searchObj.value = obj;
      dataSource.value = [];
      pageArrow.value = '';
      // 清空所有选择状态
      selectedRowKeys.value = [];
      currentPageSelectedKeys.value = [];
      currentPageSelectedRecords.value = [];
      allSelectedKeys.value.clear();
      allSelectedRecords.value.clear();
      await getData();
    };
    const changePage = async (page, pageS) => {
      let lastItem = {};
      //是否修改pageSize
      if (pageSize.value !== pageS) {
        dataSource.value = [];
        pageArrow.value = '';
        pageIndex.value = 1;
      } else {
        if (page > Number(pageIndex.value)) {
          pageArrow.value = '1';
        } else {
          pageArrow.value = '0';
        }
        pageIndex.value = page;
      }
      if (dataSource.value.length) {
        lastItem = pageArrow.value === '1' ? dataSource.value[dataSource.value.length - 1] : dataSource.value[0];
      }
      pageSize.value = pageS;
      const pageCursor = lastItem[sortBy.value ? sortBy.value : 'orderNo'] ? lastItem[sortBy.value ? sortBy.value : 'orderNo'] : '';
      const params = {
        pageCursor,
        sortBy: sortBy.value ? sortByObj[sortBy.value] : 'order_no',
        sortType: sortType.value,
        lastId: lastItem.id ? lastItem.id : '',
        lastOrderNo: lastItem.orderNo ? lastItem.orderNo : '',
        pageArrow: pageArrow.value,
        pageSize: pageSize.value,
        ...searchObj.value
      };
      await getDataSource(params);
    };
    const changePageSize = async pageS => {
      dataSource.value = [];
      pageArrow.value = '';
      pageIndex.value = 1;
      pageSize.value = pageS;
      // 清空所有选择状态
      selectedRowKeys.value = [];
      currentPageSelectedKeys.value = [];
      currentPageSelectedRecords.value = [];
      allSelectedKeys.value.clear();
      allSelectedRecords.value.clear();
      const params = {
        pageCursor: '',
        sortBy: sortBy.value ? sortByObj[sortBy.value] : 'order_no',
        sortType: sortType.value,
        lastId: '',
        lastOrderNo: '',
        pageArrow: pageArrow.value,
        pageSize: pageSize.value,
        ...searchObj.value
      };
      await getDataSource(params);
    };
    const handleTableChange = async (pagination, filters, sorter) => {
      sortBy.value = sorter.order ? sorter.columnKey : null;
      sortType.value = sorter.order === 'ascend' ? 'asc' : 'desc';
      dataSource.value = [];
      pageArrow.value = '';
      pageIndex.value = 1;
      // 清空所有选择状态
      selectedRowKeys.value = [];
      currentPageSelectedKeys.value = [];
      currentPageSelectedRecords.value = [];
      allSelectedKeys.value.clear();
      allSelectedRecords.value.clear();
      const params = {
        pageCursor: '',
        sortBy: sortBy.value ? sortByObj[sortBy.value] : 'order_no',
        sortType: sortType.value,
        lastId: '',
        lastOrderNo: '',
        pageArrow: pageArrow.value,
        pageSize: pageSize.value,
        ...searchObj.value
      };
      await getDataSource(params);
    };
    const openDetail = async item => {
      // detailVisible.value = true
      orderRef === null || orderRef === void 0 || orderRef.value.showModal(item);
    };
    const updateList = () => {
      dataSource.value = [];
      pageArrow.value = '1';
      pageIndex.value = 1;
      // 清空所有选择状态
      selectedRowKeys.value = [];
      currentPageSelectedKeys.value = [];
      currentPageSelectedRecords.value = [];
      allSelectedKeys.value.clear();
      allSelectedRecords.value.clear();
      getData();
    };
    const handleDownload = () => {
      if (!searchObj.value.dbtId) {
        return;
      }
      if (!dataSource.value.length) return message.warning('暂无数据');
      // 如果当前有勾选的数据，把勾选数据的orderNo合集处理成数组
      const orderNos = [];
      allSelectedRecords.value.forEach(records => {
        orderNos.push(...records.map(record => record.orderNo));
      });
      let params = {};
      if (orderNos.length > 0) {
        params = {
          ...searchObj.value,
          orderNos: orderNos.slice(0, 1000)
        };
        params.orderUnion = '';
      } else {
        // 判断是否是批量输入的订单号
        if (searchObj.value.orderUnion && searchObj.value.orderUnion.includes(';')) {
          params = {
            ...searchObj.value,
            orderNos: searchObj.value.orderUnion.split(';')
          };
          params.orderUnion = '';
        } else {
          params = {
            ...searchObj.value
          };
        }
      }
      if (dataSource.value.length > 1000 || orderNos.length > 1000) {
        Modal.confirm({
          title: '提示',
          centered: true,
          content: '仅支持下前1000条数据!',
          onOk: () => {
            exportOrderList(params).then(res => {
              const url = window.URL.createObjectURL(res);
              const eleA = document.createElement('a');
              eleA.href = url;
              eleA.download = `${searchObj.value.appName}.xlsx`;
              eleA.click();
              window.URL.revokeObjectURL(url);
            }).catch(err => {});
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '订单查询',
                element_name: '导出订单'
              }
            });
          }
        });
      } else {
        exportOrderList(params).then(res => {
          const url = window.URL.createObjectURL(res);
          const eleA = document.createElement('a');
          eleA.href = url;
          eleA.download = `${searchObj.value.appName}.xlsx`;
          eleA.click();
          window.URL.revokeObjectURL(url);
        }).catch(err => {});
        reportEvent({
          eventName: 'element_use',
          properties: {
            ui_name: '订单查询',
            element_name: '导出订单'
          }
        });
      }
    };
    const closeMore = bool => {
      if (!bool) {
        slotheight.value = `${window.innerHeight - 220}px`;
        tableheight.value = `${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`;
        tableMinHeight.value = `${window.innerHeight - (props.tableType === '1' ? 360 : 320)}px`;
      }
    };
    const openRefundModal = (item, isEdit = false) => {
      refundItem.value = {
        ...item,
        isEdit
      };
      refundVisible.value = true;
    };
    const initRefund = () => {
      refundItem.value = {};
    };
    const getRefundDisabledTip = record => {
      if (isRefundExpired(record)) return '该订单已过期，不支持退款';
      if (isRefundApproving(record)) return '该订单退款审批中';
      if (isRefundCompleted(record)) return '该订单已进行退款操作';
      return '该订单暂不支持退款';
    };
    const toOrderDetail = async item => {
      var _orderDetailRef$value;
      if (!((_orderDetailRef$value = orderDetailRef.value) !== null && _orderDetailRef$value !== void 0 && _orderDetailRef$value.open)) {
        return;
      }
      try {
        await orderDetailRef.value.open({
          orderNo: item.orderNo,
          dbtId: item.dbtId
        });
      } catch (error) {
        console.error('打开订单详情失败:', error);
      }
    };
    const initDataSource = () => {
      dataSource.value = [];
    };
    const onSelectChange = keys => {
      selectedRowKeys.value = keys;
      currentPageSelectedKeys.value = keys;
      // 保存当前页的选择状态
      allSelectedKeys.value.set(pageIndex.value, [...keys]);
      // 获取选中记录的详细信息
      const selectedRecords = dataSource.value.filter(record => keys.includes(record.id));
      currentPageSelectedRecords.value = selectedRecords;
      // 保存当前页选中记录的详细信息
      allSelectedRecords.value.set(pageIndex.value, [...selectedRecords]);
    };
    // 获取符合条件的选中记录数组
    const validSelectedRecords = computed(() => {
      const validRecords = [];
      allSelectedRecords.value.forEach(records => {
        const filteredRecords = records.filter(record => {
          // 排除支付状态为 0、10、30 的数据
          const excludePayStatus = [0, 10, 30].includes(Number(record.payStatus));
          if (excludePayStatus) return false;
          // 排除 createDate 超过三十天的（以秒数判断）
          const secondsDiff = dayjs(new Date()).diff(dayjs(record.createDate), 'second');
          const thirtyDaysInSeconds = 30 * 24 * 60 * 60; // 2,592,000 秒
          if (secondsDiff > thirtyDaysInSeconds) return false;
          // 排除 orderType 等于 2 的数据
          if (Number(record.orderType) === 2) return false;
          // 排除未复送的数据
          if (Number(record.prodResend) !== 0) return false;
          return true;
        });
        if (validRecords.length < 50) {
          const remaining = 50 - validRecords.length;
          validRecords.push(...filteredRecords.slice(0, remaining));
        }
      });
      return validRecords;
    });
    // 获取所有页面的总选择数量
    const totalSelectedCount = computed(() => {
      return validSelectedRecords.value.length;
    });
    const batchSendText = computed(() => {
      let length = totalSelectedCount.value;
      return length > 0 ? `批量复送(${length})` : '批量复送';
    });
    const getAllSelectedRecords = () => {
      const records = [];
      allSelectedRecords.value.forEach(items => {
        records.push(...items);
      });
      return records;
    };
    const isRefundFailed = record => Number(record.refundStatus) === 32;
    const isRefundApproving = record => [10, 30].includes(Number(record.refundStatus));
    const isRefundCompleted = record => Number(record.refundStatus) === 40 || Number(record.payStatus) === 30;
    const getPayTime = record => record.thirdPayTime || record.platStatusDate || record.clientPayStatusDate || record.createDate;
    const isPayTimeExpired = record => {
      const payTime = getPayTime(record);
      if (!payTime) return false;
      return dayjs(new Date()).diff(dayjs(payTime), 'day') > 365;
    };
    const isRefundExpired = record => isPayTimeExpired(record) && !isRefundFailed(record);
    const isRefundBaseAvailable = record => {
      return ['wxpay', 'jsapipay', 'alipay'].includes(record.payChnl) && (record.platStatus === '1' || record.clientPayStatus === '1') && Number(record.orderType) !== 2;
    };
    const isRefundAvailable = record => {
      return isRefundBaseAvailable(record) && !isRefundCompleted(record) && !isRefundApproving(record) && (!record.orderRefundId || isRefundFailed(record)) && !isRefundExpired(record);
    };
    const uniqueByOrderNo = records => {
      const orderNoSet = new Set();
      return records.filter(record => {
        const orderNo = record.orderNo;
        if (!orderNo || orderNoSet.has(orderNo)) return false;
        orderNoSet.add(orderNo);
        return true;
      });
    };
    const validRefundSelectedRecords = computed(() => uniqueByOrderNo(getAllSelectedRecords().filter(isRefundAvailable)));
    const batchRefundCount = computed(() => validRefundSelectedRecords.value.length);
    const batchRefundText = computed(() => {
      return batchRefundCount.value > 0 ? `批量退款(${batchRefundCount.value})` : '批量退款';
    });
    // 获取符合条件的选中项的orderNo数组
    const getAllSelectedOrderInfo = () => {
      return validSelectedRecords.value.map(record => record.orderNo);
    };
    const batchResend = async val => {
      switch (val) {
        case 'open':
          sureModalVisible.value = true;
          break;
        case 'handle':
          modalLoading.value = true;
          const allRecords = getAllSelectedOrderInfo();
          if (allRecords.length > 0) {
            const params = {
              orderNos: allRecords,
              prodId: validSelectedRecords.value[0].prodId,
              location: 'foreign'
            };
            try {
              let res = await resendOrder(params);
              if (res.code === '0') {
                // 接口调用成功延迟提示操作成功
                setTimeout(() => {
                  modalLoading.value = false;
                  sureModalVisible.value = false;
                  message.success('批量复送成功');
                  updateList();
                }, 2000);
              } else {
                modalLoading.value = false;
              }
            } catch (err) {}
          }
          break;
      }
    };
    const openBatchRefundModal = () => {
      if (!batchRefundCount.value) return;
      if (batchRefundCount.value > 50) {
        message.error('批量退款最多支持50笔订单');
        return;
      }
      batchRefundVisible.value = true;
    };
    const submitBatchRefund = async formData => {
      const refundRecords = validRefundSelectedRecords.value;
      const orderNoList = refundRecords.map(record => record.orderNo);
      if (!orderNoList.length) return message.error('请选择待退款订单');
      if (orderNoList.length > 50) return message.error('批量退款最多支持50笔订单');
      batchRefundLoading.value = true;
      const params = {
        orderNoList,
        refundType: formData.refundType,
        refundReason: formData.refundReason,
        customerComplaintUrl: formData.customerComplaintUrl
      };
      if (formData.refundType === 'RATIO') {
        params.refundRatio = formData.refundRatio;
      }
      const [err, res] = await awaitWrap(batchRefundSubmit(params));
      batchRefundLoading.value = false;
      if (err) return message.error('提交失败');
      if ((res === null || res === void 0 ? void 0 : res.code) === OK) {
        message.success('提交成功');
        batchRefundVisible.value = false;
        updateList();
        Modal.confirm({
          title: '提示',
          centered: true,
          content: '退款申请已提交！可前往"飞书审批"查看审批进程'
        });
      }
    };
    watch(() => props.tableType, async newVal => {
      if (newVal === '1') {
        columns.value = columnsOrder;
      } else if (newVal === '2') {
        columns.value = columnsReimburse;
      }
    }, {
      immediate: true
    });
    expose({
      searchData,
      closeMore,
      initDataSource
    });
    onMounted(() => {
      window.addEventListener('resize', () => {
        slotheight.value = `${window.innerHeight - 220}px`;
        tableheight.value = `${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`;
        tableMinHeight.value = `${window.innerHeight - (props.tableType === '1' ? 360 : 320)}px`;
      });
    });
    onBeforeUnmount(() => {
      window.removeEventListener('resize', () => {
        slotheight.value = `${window.innerHeight - 220}px`;
        tableheight.value = `${window.innerHeight - (props.tableType === '1' ? 400 : 360)}px`;
        tableMinHeight.value = `${window.innerHeight - (props.tableType === '1' ? 360 : 320)}px`;
      });
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_statistic = _resolveComponent("a-statistic");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_select = _resolveComponent("a-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.tableType == '1' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        disabled: _unref(totalSelectedCount) === 0,
        onClick: _cache[0] || (_cache[0] = $event => batchResend('open'))
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(batchSendText)), 1)]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), __props.tableType == '1' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 1,
        class: "batch-refund-btn",
        disabled: _unref(batchRefundCount) === 0,
        onClick: openBatchRefundModal
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(batchRefundText)), 1)]),
        _: 1
      }, 8, ["disabled"])) : _createCommentVNode("", true), __props.tableType == '1' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 2,
        onClick: handleDownload,
        class: "download-btn"
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "export",
          "class-name": "download-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 导出订单 ")]),
        _: 1
      })) : _createCommentVNode("", true)]), __props.tableType === '1' ? (_openBlock(), _createBlock(_component_a_table, {
        key: 0,
        bordered: "",
        columns: columns.value,
        "data-source": dataSource.value,
        "row-key": "id",
        pagination: false,
        ref_key: "tableRef",
        ref: tableRef,
        loading: loading.value,
        onChange: handleTableChange,
        "row-selection": {
          selectedRowKeys: selectedRowKeys.value,
          onChange: onSelectChange,
          getCheckboxProps: record => ({
            disabled: record.orderType === 2
          })
        },
        scroll: {
          y: tableheight.value,
          x: 1500
        },
        class: "new-order-table"
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref2, _payStatusList$filter, _unref$filter;
          return [column.dataIndex === 'orderNo' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 0
          }, {
            title: _withCtx(() => [_createTextVNode("点击复制订单号")]),
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "word-break": "break-all",
                "cursor": "pointer"
              },
              class: "order-copy-value",
              onClick: $event => _unref(copy)(record[column.dataIndex])
            }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_3)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'platOrderNo' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1
          }, {
            title: _withCtx(() => [_createTextVNode("点击复制三方订单号")]),
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "word-break": "break-all",
                "cursor": "pointer"
              },
              class: "order-copy-value",
              onClick: $event => _unref(copy)(record[column.dataIndex])
            }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_4)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'deviceId' ? (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 2
          }, {
            title: _withCtx(() => [_createTextVNode("点击复制设备ID")]),
            default: _withCtx(() => [_createElementVNode("div", {
              style: {
                "word-break": "break-all",
                "cursor": "pointer"
              },
              class: "order-copy-value",
              onClick: $event => _unref(copy)(record[column.dataIndex])
            }, _toDisplayString(record[column.dataIndex]), 9, _hoisted_5)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true), column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [isRefundBaseAvailable(record) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [isRefundAvailable(record) ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "link",
            onClick: $event => openRefundModal(record, isRefundFailed(record))
          }, {
            default: _withCtx(() => [_createTextVNode(" 退款 ")]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_a_tooltip, {
            key: 1
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(getRefundDisabledTip(record)), 1)]),
            default: _withCtx(() => [_createVNode(_component_a_button, {
              type: "link",
              disabled: ""
            }, {
              default: _withCtx(() => [_createTextVNode("退款")]),
              _: 1
            })]),
            _: 2
          }, 1024))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => openDetail(record),
            disabled: Number(record.orderType) == 2
          }, {
            default: _withCtx(() => [_createTextVNode(" 复送 ")]),
            _: 2
          }, 1032, ["onClick", "disabled"])])])), [[_directive_permission, {
            permissionValue: 'orderList',
            permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
          }]]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => toOrderDetail(record)
          }, {
            default: _withCtx(() => [_createTextVNode("详情")]),
            _: 2
          }, 1032, ["onClick"])])])) : _createCommentVNode("", true), column.dataIndex === 'amount' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(record['currency']), 1), _createVNode(_component_a_statistic, {
            value: record['amount']
          }, null, 8, ["value"])])) : _createCommentVNode("", true), column.dataIndex === 'payStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 5,
            class: _normalizeClass(["title-value", {
              success: record.payStatus == 20 || record.payStatus == 21 || record.payStatus == 22,
              error: record.payStatus == 10
            }])
          }, _toDisplayString((_payStatusList$filter = payStatusList.filter(item => item.value == record.payStatus)) === null || _payStatusList$filter === void 0 || (_payStatusList$filter = _payStatusList$filter[0]) === null || _payStatusList$filter === void 0 ? void 0 : _payStatusList$filter.label), 3)) : _createCommentVNode("", true), column.dataIndex === 'shipStatus' ? (_openBlock(), _createElementBlock("span", {
            key: 6,
            class: _normalizeClass(["title-value", {
              success: record.shipStatus == 10 || record.shipStatus == 12,
              error: record.shipStatus == 0
            }])
          }, _toDisplayString(record.shipStatus || record.shipStatus === 0 ? (_unref$filter = _unref(shipStatusList).filter(item => item.value == record.shipStatus)) === null || _unref$filter === void 0 || (_unref$filter = _unref$filter[0]) === null || _unref$filter === void 0 ? void 0 : _unref$filter.label : '-'), 3)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["columns", "data-source", "loading", "row-selection", "scroll"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createTextVNode(" 共 "), _createElementVNode("span", null, _toDisplayString(total.value), 1), _createTextVNode(" 条 ")]), _createVNode(_component_a_button, {
        disabled: pageIndex.value === 1 || loading.value,
        onClick: _cache[1] || (_cache[1] = $event => changePage(pageIndex.value - 1, pageSize.value)),
        style: {
          "padding": "4px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "arrow",
          style: {
            "transform": "rotate(-90deg)"
          }
        })]),
        _: 1
      }, 8, ["disabled"]), _createElementVNode("span", _hoisted_14, _toDisplayString(pageIndex.value), 1), _createVNode(_component_a_button, {
        disabled: !dataSource.value.length || dataSource.value.length < pageSize.value || !hasNextPage.value || loading.value,
        onClick: _cache[2] || (_cache[2] = $event => changePage(pageIndex.value + 1, pageSize.value)),
        style: {
          "padding": "4px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "arrow",
          style: {
            "transform": "rotate(90deg)"
          }
        })]),
        _: 1
      }, 8, ["disabled"]), _createVNode(_component_a_select, {
        style: {
          "margin-left": "8px",
          "width": "100px"
        },
        onChange: changePageSize,
        options: pageSizeList,
        value: pageSize.value,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => pageSize.value = $event)
      }, null, 8, ["value"])]), _createVNode(OrderModal, {
        onUpdateList: updateList,
        ref_key: "orderRef",
        ref: orderRef
      }, null, 512), _createVNode(RefundModal, {
        "modal-visible": refundVisible.value,
        "onUpdate:modal-visible": _cache[4] || (_cache[4] = $event => refundVisible.value = $event),
        "order-info": refundItem.value,
        onInitRefund: initRefund,
        onUpdateList: updateList
      }, null, 8, ["modal-visible", "order-info"]), _createVNode(OrderDetail, {
        ref_key: "orderDetailRef",
        ref: orderDetailRef
      }, null, 512), _createVNode(BatchSureModal, {
        modalVisible: sureModalVisible.value,
        "onUpdate:modalVisible": _cache[5] || (_cache[5] = $event => sureModalVisible.value = $event),
        modalLoading: modalLoading.value,
        onSubmitOk: batchResend
      }, null, 8, ["modalVisible", "modalLoading"]), _createVNode(BatchRefundModal, {
        modalVisible: batchRefundVisible.value,
        "onUpdate:modalVisible": _cache[6] || (_cache[6] = $event => batchRefundVisible.value = $event),
        records: _unref(validRefundSelectedRecords),
        "submit-loading": batchRefundLoading.value,
        onSubmit: submitBatchRefund
      }, null, 8, ["modalVisible", "records", "submit-loading"])]);
    };
  }
});